module.exports = __webpack_public_path__ + "static/media/Faq-image.385d395b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/pages/images/Faq-image.jpg
// module id = 945
// module chunks = 0